import { render, staticRenderFns } from "./Visualizar.vue?vue&type=template&id=47e72ce2"
import script from "./Visualizar.vue?vue&type=script&lang=js"
export * from "./Visualizar.vue?vue&type=script&lang=js"
import style0 from "./Visualizar.vue?vue&type=style&index=0&id=47e72ce2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports